import { Text, TextProps } from '@chakra-ui/react'

export default Text

export type { TextProps }
